import { CoreDataPoint } from "../../../Components/Shared/CoreComponents";

export enum AdHocReportFixedWhereOperator {
    Equals = 'Equals',
    NotEquals = 'NotEquals',
    GreaterThan = 'GreaterThan',
    GreaterThanOrEqual = 'GreaterThanOrEqual',
    LessThan = 'LessThan',
    LessThanOrEqual = 'LessThanOrEqual',
    Between = 'Between',
    Contains = 'Contains',
    StartsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    IsNull = 'IsNull',
    IsNotNull = 'IsNotNull'
};

export default interface AdHocReportFixedWhereModel {
    coreTypeID: number;
    where: AdHocReportFixedWhereOperator;
    valueLHS: null | string;
    valueRHS: null | string;
    fixedCoreDataPointModel: CoreDataPoint;
}
